export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = "https://api.brasilplay.site";
export const BASE_URL_V1 = BASE_URL + "/v1/";
export const MERCADOPAGO_PUBLIC_KEY = process.env.REACT_APP_MERCADO_PUBLIC_KEY||"APP_USR-4fd061fa-642b-4232-9044-b5476d18c3b3";

// const recordID = "{recordID}";
// const activateURL = "activate/" + recordID;
// const inActivateURL = "inactivate/" + recordID;
// const publish = "publish/" + recordID;
// const unpublish = "unPublish/" + recordID;
// const deleteURL = "delete/" + recordID;
// const reviveURL = "revive/" + recordID;
// const deletedListURL = "deleted-list";
// const listURL = "list";
// const updateUrl = "update/";
const login = "/login"

// Login
export const PLAYER_LOGIN_URL = BASE_URL + "/auth/player-login";
export const PLAYER_DASHBOARD_URL = BASE_URL_V1 + "player-dashboard/";


//Player Controller
export const BASE_URL_PLAYER = BASE_URL_V1 + "player/";
export const PLAYER_TEMPLATE_LIST_GET = PLAYER_DASHBOARD_URL + "getTemplateList";
export const GET_PLAYER_DENOMINATION_GET = PLAYER_DASHBOARD_URL + "getDenomination";
export const GET_PLAYER_BALANCE_GET = PLAYER_DASHBOARD_URL + "getWalletBalance";
export const PLAYER_AVATAR_LIST_GET = BASE_URL_PLAYER + "avatarList";
// export const PLAYER_PROFILE_UPDATE_PUT = BASE_URL_PLAYER + "updateProfile";
export const PLAYER_CREATE_ACCOUNT_POST = BASE_URL_PLAYER + "register";
export const PLAYER_CHANGE_PASSWORD_PUT = BASE_URL_PLAYER + "resetPassword";
export const PLAYER_PROFILE_GET = BASE_URL_PLAYER + "getPlayerDetails";
export const PLAYER_PROFILE_UPDATE_POST = BASE_URL_PLAYER + "player-profile/update";
export const PLAYER_PROFILE_UPDATE_PUT = BASE_URL_PLAYER + "updateProfile";
export const PLAYER_ADDRESS_UPDATE_POST = BASE_URL_PLAYER + "player-address/update";
export const PLAYER_DEPOSIT_POST = BASE_URL_PLAYER + "create";
export const PLAYER_TRANSACTION_HISTORY_GET = BASE_URL_PLAYER + "transactionHistory/{startDate}/{endDate}";
export const SAVE_BANK_DETAILS_POST = BASE_URL_PLAYER + "savePlayerBankDetail";
export const GET_BANK_DETAILS_GET = BASE_URL_PLAYER + "getPlayerBankDetail";

// Guest Controller 
export const BASE_URL_GUEST = BASE_URL + "/guest/";
export const PLAYER_GUEST_COUNTRY_LIST_GET = BASE_URL_GUEST + "countryList";
export const PLAYER_GUEST_STATE_LIST_GET = BASE_URL_GUEST + "stateList/{countryId}";
export const PLAYER_GUEST_CITY_LIST_GET = BASE_URL_GUEST + "cityList/{stateId}";
export const GET_STATIC_DATA_GET = BASE_URL_GUEST + "page/{websiteCmsKey}";

// GamePlay Controller
export const GET_TEMPLATE_DETAILS_GET = PLAYER_DASHBOARD_URL + "getTemplateDetail/{recordId}";
export const GET_GAME_PLAY_RESULT_POST = BASE_URL_V1 + "slot-gameplay/getGameResult/{templateId}";
export const SET_GAME_BONUS_RESULT_POST = BASE_URL_V1 + "slot-gameplay/getBonusResult";
export const RESET_BALANCE_AMT_POST = BASE_URL_V1 + "slot-gameplay/resetBalance";
export const ADD_BALANCE_AMT_POST = BASE_URL_V1 + "slot-gameplay/addBalance";

export const GET_PAYMENT_STATUS_GET = BASE_URL_PLAYER + "transactionStatus/{provider}/{paymentId}";



//withdraw
export const PLAYER_WITHDRAWAL_POST = BASE_URL_PLAYER + "withdrawRequest";
export const PLAYER_WITHDRAWAL_HISTORY_POST = BASE_URL_PLAYER + "withdrawMoneyRequestList";